import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ListItem, STYLES } from './consts';
import { ReactComponent as Divider } from '../../assets/svg/divider.svg';
import { ReactComponent as RightArrow } from '../../assets/svg/arrow-right-v2.svg';
import Heading from '../../generic-components/Heading';
import { CloseButton } from '../../DesignSystem/LiliCloseButton/CloseButton';

interface IProps {
    list?: ListItem[];
    pageTitle: string;
    onCloseAction: () => void;
    layoutStyle?: string
}
export const NavigationHeader = ({
  list, pageTitle, onCloseAction, layoutStyle,
} :IProps) => {
  const { t } = useTranslation();

  return (
    <div className={layoutStyle || STYLES.MAIN_WRAPPER}>
      <div className='flex items-center'>
        <CloseButton onClick={onCloseAction} className='' id='headerCloseButton' />
        {list && list.length && (
          <div className='ml-[10px] flex items-center'>
            <Divider className={STYLES.DIVIDER} />
            {list.map((item, index) => (
              <React.Fragment key={`${item?.name}`}>
                <NavLink
                  className={index === list.length - 1 ? STYLES.LINK_ACTIVE : STYLES.LINK}
                  to={item.path || ''}
                >
                  {t(item.name, item.name)}
                </NavLink>
                {index !== list.length - 1 && <RightArrow />}
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
      <div>
        <Heading title={pageTitle} className={STYLES.MAIN_TITLE} />
      </div>
    </div>
  );
};
